module.exports = " <div class=text> <textarea></textarea> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Text.vue
// module id = 729
// module chunks = 2